import { useLayoutEffect, useState } from 'react';
import debounce from 'react-utils/debounce';
function getSize() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}
export function useWindowSize() {
  const [size, setSize] = useState(getSize());
  useLayoutEffect(() => {
    const handleResize = debounce(() => {
      setSize(getSize());
    }, 200);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return size;
}